import React from 'react';
import { BaseButton, BaseButtonProps } from '@components/buttons/BaseButton';

export interface PrimaryButtonProps extends Omit<BaseButtonProps, 'variant'> {
    variant?: 'primary' | 'gradient' | 'outlined';
}

export const PrimaryButton: React.FC<PrimaryButtonProps> = ({
    variant = 'primary',
    gradient = variant === 'gradient',
    ...props
}) => {
    return (
        <BaseButton
            variant={variant === 'outlined' ? 'outline' : 'primary'}
            gradient={gradient}
            {...props}
        />
    );
};

export default PrimaryButton;

